import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth/auth-guard';
import { AuthResolver } from './core/auth/auth-resolver';

// Layouts
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { LandingLayoutComponent } from './layouts/landing-layout/landing-layout.component';

import { EmailSuccessComponent } from './juegos/components/verification/email-success.component';
import { VerificationComponent } from './juegos/components/verification/verification.component';

export const routes: Routes = [
  {
    path: '',
    resolve: {
      authReady: AuthResolver
    },
    children: [
      {
        path: '',
        redirectTo: 'landing/home',
        pathMatch: 'full',
      },
      {
        path: '',
        component: LandingLayoutComponent,
        children: [
          {
            path: 'landing',
            loadChildren: './landing/landing.module#LandingModule'
          }
        ]
      },
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: 'pages',
            loadChildren: './pages/pages.module#PagesModule',
          }
        ]
      },
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: 'juegos',
            loadChildren: './juegos/juegos.module#JuegosModule'
          }
        ]
      },
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: 'contact-us',
            loadChildren: './contact-us/contact-us.module#ContactUsModule'
          }
        ]
      },
      {
        path: '',
        component: SimpleLayoutComponent,
        children: [
          {
            path: 'email-verified/:username',
            component: EmailSuccessComponent
          }
        ]
      },
/*      {
        path: '',
        component: SimpleLayoutComponent,
        children: [
          {
            path: 'verification',
            component: VerificationComponent
          }
        ]
      },*/
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: 'account',
            loadChildren: './account/account.module#AccountModule'
          }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/app.routing.ts